'use strict';

const tileImage = require('../utils/tileImage');

/**
* Updates the progress bar for a slider
* @param {jQuery} $parent - The parent element containing the progress bar and label
* @param {number} nextSlide - The index of the next slide
* @param {number} slideCount - The total number of slides
* @param {number} slidesToShow - The number of slides to be displayed at a time
* @returns {void}
*/
function updateProgressBar($parent, nextSlide, slideCount, slidesToShow) {
    let calc;
    let $progressBar = $parent.find('.progress');
    let $progressBarLabel = $parent.find('.slider__label');

    if (nextSlide === 0) {
        calc = 0;
    } else {
        calc = ((nextSlide + 1) / (slideCount - slidesToShow + 1)) * 100;
    }

    $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
    $progressBarLabel.text(calc + '% completed');
}

/**
* Returns the options for the slider component
* @returns {Object} options for the slider
*/
function getSliderOptions() {
    return {
        slidesToShow: 4,
        slidesToScroll: 2,
        dots: false,
        focusOnSelect: false,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 544,
                settings: {
                    slidesToShow: 1.5,
                    arrows: true,
                    slidesToScroll: 1
                }
            }
        ]
    };
}

/**
 * Builds the popup-specific slick options
 * @returns {Object} options for the popup slider
 */
function getPopupSliderOptions() {
    return $.extend({}, getSliderOptions(), {
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 544,
                settings: {
                    slidesToShow: 1.5,
                    arrows: true,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

/**
 * Initializes a single recommendation slider with its own options and progress handler.
 * Each carousel must be initialized independently so multiple carousels on the same page
 * do not share the same options object (slick keeps the `responsive` array by reference).
 * @param {HTMLElement} element - the .product-grid element to initialize
 */
function initSingleRecommendationSlick(element) {
    let $grid = $(element);
    let isPopup = $grid.closest('.added-to-cart-popup').length > 0;
    let options = isPopup ? getPopupSliderOptions() : getSliderOptions();

    $grid.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        updateProgressBar($grid.parent(), nextSlide, slick.slideCount, slick.options.slidesToShow);
    });

    $grid.slick(options);
    $grid.closest('.product-recommendations').find('.image-container').each(function (index, el) {
        tileImage.initHoverImageContainer($(el));
    });
}

/**
 * Init product recommendation slick
 */
function initProductRecommendationSlick() {
    $(document).ready(function () {
        $('.product-recommendations .product-grid').not('.slick-initialized').each(function () {
            initSingleRecommendationSlick(this);
        });
    });
}

/**
 * Obfuscation of the href
 */
function obfuscationEinstein() {
    $('body').on('click', '.image-container .link-cbo', function (e) {
        e.stopPropagation();
        var encodedUrl = $(this).attr('data-cbo');
        var showMoreUrl = decodeURIComponent(window.atob(encodedUrl));
        var imageReplaceURL = showMoreUrl.replace('#', '%23');
        window.location.href = imageReplaceURL;
    });
}

/**
 * Init quick access feature
 */
function initRecommandationLogic() {
    $(function () {
        initProductRecommendationSlick();
        obfuscationEinstein();
    });
}

module.exports = {
    getSliderOptions, updateProgressBar, initRecommandationLogic, obfuscationEinstein, initProductRecommendationSlick
};
